export const CountryCode2Locale = {
    AF: "fa-AF",
    AL: "sq-AL",
    DZ: "ar-DZ",
    AS: "en-AS",
    AD: "ca-AD",
    AO: "pt-AO",
    AQ: "en-AQ",
    AG: "en-AG",
    AR: "es-AR",
    AM: "hy-AM",
    AU: "en-AU",
    AT: "de-AT",
    AZ: "az-AZ",
    BH: "ar-BH",
    BD: "bn-BD",
    BB: "en-BB",
    BE: "nl-BE",
    BZ: "en-BZ",
    BJ: "fr-BJ",
    BT: "dz-BT",
    BO: "es-BO",
    BA: "bs-BA",
    BW: "en-BW",
    BR: "pt-BR",
    BN: "ms-BN",
    BG: "bg-BG",
    BF: "fr-BF",
    BI: "fr-BI",
    CV: "pt-CV",
    KH: "km-KH",
    CM: "fr-CM",
    CA: "en-CA",
    BQ: "nl-BQ",
    CF: "fr-CF",
    TD: "fr-TD",
    CL: "es-CL",
    CN: "zh-CN",
    CX: "en-CX",
    CC: "en-CC",
    CO: "es-CO",
    KM: "ar-KM",
    CK: "en-CK",
    CR: "es-CR",
    CI: "fr-CI",
    HR: "hr-HR",
    CW: "nl-CW",
    CY: "el-CY",
    CZ: "cs-CZ",
    CD: "fr-CD",
    DK: "da-DK",
    DJ: "fr-DJ",
    DM: "en-DM",
    DO: "es-DO",
    EC: "es-EC",
    EG: "ar-EG",
    SV: "es-SV",
    GQ: "es-GQ",
    ER: "ti-ER",
    EE: "et-EE",
    SZ: "en-SZ",
    ET: "am-ET",
    FJ: "en-FJ",
    FI: "fi-FI",
    FR: "fr-FR",
    PF: "fr-PF",
    TF: "fr-TF",
    GA: "fr-GA",
    GE: "ka-GE",
    DE: "de-DE",
    GH: "en-GH",
    GR: "el-GR",
    GD: "en-GD",
    GU: "en-GU",
    GT: "es-GT",
    GG: "en-GG",
    GN: "fr-GN",
    GW: "pt-GW",
    GY: "en-GY",
    HT: "fr-HT",
    HM: "en-HM",
    HN: "es-HN",
    HU: "hu-HU",
    IS: "is-IS",
    IN: "hi-IN",
    ID: "id-ID",
    IQ: "ar-IQ",
    IE: "en-IE",
    IM: "en-IM",
    IL: "he-IL",
    IT: "it-IT",
    JM: "en-JM",
    JP: "ja-JP",
    JE: "en-JE",
    JO: "ar-JO",
    KZ: "kk-KZ",
    KE: "en-KE",
    KI: "en-KI",
    KW: "ar-KW",
    KG: "ky-KG",
    LA: "lo-LA",
    LV: "lv-LV",
    LB: "ar-LB",
    LS: "en-LS",
    LR: "en-LR",
    LY: "ar-LY",
    LI: "de-LI",
    LT: "lt-LT",
    LU: "lb-LU",
    MG: "fr-MG",
    MW: "en-MW",
    MY: "ms-MY",
    MV: "dv-MV",
    ML: "fr-ML",
    MT: "mt-MT",
    MH: "en-MH",
    MR: "ar-MR",
    MU: "en-MU",
    MX: "es-MX",
    FM: "en-FM",
    MD: "ro-MD",
    MC: "fr-MC",
    MN: "mn-MN",
    ME: "sr-ME",
    MA: "ar-MA",
    MZ: "pt-MZ",
    MM: "my-MM",
    NA: "en-NA",
    NR: "en-NR",
    NP: "ne-NP",
    NL: "nl-NL",
    NC: "fr-NC",
    NZ: "en-NZ",
    NI: "es-NI",
    NE: "fr-NE",
    NG: "en-NG",
    NU: "en-NU",
    NF: "en-NF",
    MK: "mk-MK",
    MP: "en-MP",
    NO: "nb-NO",
    OM: "ar-OM",
    PK: "ur-PK",
    PW: "en-PW",
    PA: "es-PA",
    PG: "en-PG",
    PY: "es-PY",
    PE: "es-PE",
    PH: "en-PH",
    PN: "en-PN",
    PL: "pl-PL",
    PT: "pt-PT",
    QA: "ar-QA",
    CG: "fr-CG",
    RO: "ro-RO",
    RW: "rw-RW",
    BL: "fr-BL",
    SH: "en-SH",
    KN: "en-KN",
    LC: "en-LC",
    MF: "fr-MF",
    PM: "fr-PM",
    VC: "en-VC",
    WS: "sm-WS",
    SM: "it-SM",
    ST: "pt-ST",
    SA: "ar-SA",
    SN: "fr-SN",
    RS: "sr-RS",
    SC: "en-SC",
    SL: "en-SL",
    SG: "en-SG",
    SX: "nl-SX",
    SK: "sk-SK",
    SI: "sl-SI",
    SB: "en-SB",
    SO: "so-SO",
    ZA: "en-ZA",
    GS: "en-GS",
    KR: "ko-KR",
    SS: "en-SS",
    ES: "es-ES",
    LK: "si-LK",
    SD: "ar-SD",
    SR: "nl-SR",
    SE: "sv-SE",
    CH: "de-CH",
    TJ: "tg-TJ",
    TZ: "sw-TZ",
    TH: "th-TH",
    BS: "en-BS",
    GM: "en-GM",
    TL: "pt-TL",
    TG: "fr-TG",
    TK: "en-TK",
    TO: "en-TO",
    TT: "en-TT",
    TN: "ar-TN",
    TR: "tr-TR",
    TM: "tk-TM",
    TV: "en-TV",
    UG: "en-UG",
    UA: "uk-UA",
    AE: "ar-AE",
    GB: "en-GB",
    US: "en-US",
    UM: "en-UM",
    UY: "es-UY",
    UZ: "uz-UZ",
    VU: "bi-VU",
    VA: "it-VA",
    VE: "es-VE",
    VN: "vi-VN",
    WF: "fr-WF",
    YE: "ar-YE",
    ZM: "en-ZM",
    ZW: "en-ZW",
};

/* export const Locale2LanguageName = {
    "am-ET": "አማርኛ (ኢትዮጵያ)",
    "ar-AE": "العربية (الإمارات العربية المتحدة)",
    "ar-BH": "العربية (البحرين)",
    "ar-DZ": "العربية (الجزائر)",
    "ar-EG": "العربية (مصر)",
    "ar-IQ": "العربية (العراق)",
    "ar-JO": "العربية (الأردن)",
    "ar-KM": "العربية (جزر القمر)",
    "ar-KW": "العربية (الكويت)",
    "ar-LB": "العربية (لبنان)",
    "ar-LY": "العربية (ليبيا)",
    "ar-MA": "العربية (المغرب)",
    "ar-MR": "العربية (موريتانيا)",
    "ar-OM": "العربية (عُمان)",
    "ar-QA": "العربية (قطر)",
    "ar-SA": "العربية (السعودية)",
    "ar-SD": "العربية (السودان)",
    "ar-TN": "العربية (تونس)",
    "ar-YE": "العربية (اليمن)",
    "az-AZ": "Azərbaycanca (Azərbaycan)",
    "bi-VU": "Bislama (Vanuatu)",
    "bn-BD": "বাংলা (বাংলাদেশ)",
    "bg-BG": "Български (България)",
    "bs-BA": "Bosanski (Bosna i Hercegovina)",
    "ca-AD": "Català (Andorra)",
    "cs-CZ": "Čeština (Česká republika)",
    "da-DK": "Dansk (Danmark)",
    "de-AT": "Deutsch (Österreich)",
    "de-CH": "Deutsch (Schweiz)",
    "de-DE": "Deutsch (Deutschland)",
    "de-LI": "Deutsch (Liechtenstein)",
    "dv-MV": "ދިވެހި (Maldives)",
    "dz-BT": "རྫོང་ཁ (འབྲུག)",
    "el-CY": "Ελληνικά (Κύπρος)",
    "el-GR": "Ελληνικά (Ελλάδα)",
    "en-AG": "English (Antigua and Barbuda)",
    "en-AQ": "English (Antarctica)",
    "en-AS": "English (American Samoa)",
    "en-AU": "English (Australia)",
    "en-BB": "English (Barbados)",
    "en-BS": "English (Bahamas)",
    "en-BW": "English (Botswana)",
    "en-BZ": "English (Belize)",
    "en-CA": "English (Canada)",
    "en-CC": "English (Cocos (Keeling) Islands)",
    "en-CK": "English (Cook Islands)",
    "en-CX": "English (Christmas Island)",
    "en-DM": "English (Dominica)",
    "en-FJ": "English (Fiji)",
    "en-FM": "English (Micronesia)",
    "en-GB": "English (United Kingdom)",
    "en-GD": "English (Grenada)",
    "en-GG": "English (Guernsey)",
    "en-GH": "English (Ghana)",
    "en-GM": "English (Gambia)",
    "en-GS": "English (South Georgia and the South Sandwich Islands)",
    "en-GU": "English (Guam)",
    "en-GY": "English (Guyana)",
    "en-HM": "English (Heard Island and McDonald Islands)",
    "en-IE": "English (Ireland)",
    "en-IM": "English (Isle of Man)",
    "en-JE": "English (Jersey)",
    "en-JM": "English (Jamaica)",
    "en-KE": "English (Kenya)",
    "en-KI": "English (Kiribati)",
    "en-KN": "English (Saint Kitts and Nevis)",
    "en-LC": "English (Saint Lucia)",
    "en-LR": "English (Liberia)",
    "en-LS": "English (Lesotho)",
    "en-MH": "English (Marshall Islands)",
    "en-MP": "English (Northern Mariana Islands)",
    "en-MU": "English (Mauritius)",
    "en-MW": "English (Malawi)",
    "en-NA": "English (Namibia)",
    "en-NF": "English (Norfolk Island)",
    "en-NG": "English (Nigeria)",
    "en-NR": "English (Nauru)",
    "en-NU": "English (Niue)",
    "en-NZ": "English (New Zealand)",
    "en-PG": "English (Papua New Guinea)",
    "en-PH": "English (Philippines)",
    "en-PN": "English (Pitcairn Islands)",
    "en-PW": "English (Palau)",
    "en-SB": "English (Solomon Islands)",
    "en-SC": "English (Seychelles)",
    "en-SG": "English (Singapore)",
    "en-SH": "English (Saint Helena)",
    "en-SL": "English (Sierra Leone)",
    "en-SS": "English (South Sudan)",
    "en-SZ": "English (Eswatini)",
    "en-TK": "English (Tokelau)",
    "en-TO": "English (Tonga)",
    "en-TT": "English (Trinidad and Tobago)",
    "en-TV": "English (Tuvalu)",
    "en-UG": "English (Uganda)",
    "en-UM": "English (U.S. Outlying Islands)",
    "en-US": "English (United States)",
    "en-VC": "English (Saint Vincent and the Grenadines)",
    "en-ZA": "English (South Africa)",
    "en-ZM": "English (Zambia)",
    "en-ZW": "English (Zimbabwe)",
    "es-AR": "Español (Argentina)",
    "es-BO": "Español (Bolivia)",
    "es-CL": "Español (Chile)",
    "es-CO": "Español (Colombia)",
    "es-CR": "Español (Costa Rica)",
    "es-DO": "Español (República Dominicana)",
    "es-EC": "Español (Ecuador)",
    "es-ES": "Español (España)",
    "es-GQ": "Español (Guinea Ecuatorial)",
    "es-GT": "Español (Guatemala)",
    "es-HN": "Español (Honduras)",
    "es-MX": "Español (México)",
    "es-NI": "Español (Nicaragua)",
    "es-PA": "Español (Panamá)",
    "es-PE": "Español (Perú)",
    "es-PY": "Español (Paraguay)",
    "es-SV": "Español (El Salvador)",
    "es-UY": "Español (Uruguay)",
    "es-VE": "Español (Venezuela)",
    "et-EE": "Eesti (Eesti)",
    "fa-AF": "فارسی (افغانستان)",
    "fi-FI": "Suomi (Suomi)",
    "fr-BF": "Français (Burkina Faso)",
    "fr-BI": "Français (Burundi)",
    "fr-BJ": "Français (Bénin)",
    "fr-BL": "Français (Saint-Barthélemy)",
    "fr-CD": "Français (République démocratique du Congo)",
    "fr-CF": "Français (République centrafricaine)",
    "fr-CG": "Français (Congo)",
    "fr-CI": "Français (Côte d’Ivoire)",
    "fr-CM": "Français (Cameroun)",
    "fr-DJ": "Français (Djibouti)",
    "fr-FR": "Français (France)",
    "fr-GA": "Français (Gabon)",
    "fr-GN": "Français (Guinée)",
    "fr-HT": "Français (Haïti)",
    "fr-MC": "Français (Monaco)",
    "fr-MF": "Français (Saint-Martin)",
    "fr-MG": "Français (Madagascar)",
    "fr-MG": "Français (Madagascar)",
    "fr-ML": "Français (Mali)",
    "fr-NC": "Français (Nouvelle-Calédonie)",
    "fr-NC": "Français (Nouvelle-Calédonie)",
    "fr-NE": "Français (Niger)",
    "fr-NE": "Français (Niger)",
    "fr-PF": "Français (Polynésie française)",
    "fr-PM": "Français (Saint-Pierre-et-Miquelon)",
    "fr-SN": "Français (Sénégal)",
    "fr-TD": "Français (Tchad)",
    "fr-TD": "Français (Tchad)",
    "fr-TF": "Français (Terres australes françaises)",
    "fr-TG": "Français (Togo)",
    "fr-WF": "Français (Wallis-et-Futuna)",
    "he-IL": "עברית (ישראל)",
    "hi-IN": "हिन्दी (भारत)",
    "hr-HR": "Hrvatski (Hrvatska)",
    "hu-HU": "Magyar (Magyarország)",
    "hy-AM": "Հայերեն (Հայաստան)",
    "id-ID": "Bahasa Indonesia (Indonesia)",
    "is-IS": "Íslenska (Ísland)",
    "it-IT": "Italiano (Italia)",
    "it-SM": "Italiano (San Marino)",
    "it-VA": "Italiano (Vaticano)",
    "ja-JP": "日本語 (日本)",
    "ka-GE": "ქართული (საქართველო)",
    "kk-KZ": "Қазақ тілі (Қазақстан)",
    "km-KH": "ភាសាខ្មែរ (កម្ពុជា)",
    "ko-KR": "한국어 (대한민국)",
    "ky-KG": "Кыргызча (Кыргызстан)",
    "lb-LU": "Lëtzebuergesch (Lëtzebuerg)",
    "lo-LA": "ລາວ (ລາວ)",
    "lt-LT": "Lietuvių (Lietuva)",
    "lv-LV": "Latviešu (Latvija)",
    "mk-MK": "Македонски (Северна Македонија)",
    "mn-MN": "Монгол (Монгол)",
    "ms-BN": "Bahasa Melayu (Brunei)",
    "ms-MY": "Bahasa Melayu (Malaysia)",
    "mt-MT": "Malti (Malta)",
    "my-MM": "မြန်မာစာ (မြန်မာ)",
    "nb-NO": "Norsk bokmål (Norge)",
    "ne-NP": "नेपाली (नेपाल)",
    "nl-BE": "Nederlands (België)",
    "nl-BQ": "Nederlands (Caribisch Nederland)",
    "nl-CW": "Nederlands (Curaçao)",
    "nl-NL": "Nederlands (Nederland)",
    "nl-SR": "Nederlands (Suriname)",
    "nl-SX": "Nederlands (Sint Maarten)",
    "pl-PL": "Polski (Polska)",
    "pt-AO": "Português (Angola)",
    "pt-BR": "Português (Brasil)",
    "pt-CV": "Português (Cabo Verde)",
    "pt-GW": "Português (Guiné-Bissau)",
    "pt-MZ": "Português (Moçambique)",
    "pt-PT": "Português (Portugal)",
    "pt-ST": "Português (São Tomé e Príncipe)",
    "pt-TL": "Português (Timor-Leste)",
    "ro-MD": "Română (Republica Moldova)",
    "ro-RO": "Română (România)",
    "rw-RW": "Kinyarwanda (Rwanda)",
    "si-LK": "සිංහල (ශ්‍රී ලංකාව)",
    "sk-SK": "Slovenčina (Slovensko)",
    "sl-SI": "Slovenščina (Slovenija)",
    "sm-WS": "Gagana Samoa (Samoa)",
    "so-SO": "Soomaali (Soomaaliya)",
    "sq-AL": "Shqip (Shqipëri)",
    "sr-ME": "Српски (Црна Гора)",
    "sr-RS": "Српски (Србија)",
    "sv-SE": "Svenska (Sverige)",
    "sw-TZ": "Kiswahili (Tanzania)",
    "tg-TJ": "Тоҷикӣ (Тоҷикистон)",
    "th-TH": "ไทย (ประเทศไทย)",
    "ti-ER": "ትግርኛ (ኤርትራ)",
    "tk-TM": "Türkmençe (Türkmenistan)",
    "tr-TR": "Türkçe (Türkiye)",
    "uk-UA": "Українська (Україна)",
    "ur-PK": "اردو (پاکستان)",
    "uz-UZ": "O‘zbekcha (O‘zbekiston)",
    "vi-VN": "Tiếng Việt (Việt Nam)",
    "zh-CN": "中文 (中国)",
}; */
export const Locale2LanguageName = {
    az: "Azərbaycanca",
    id: "Bahasa Indonesia",
    ms: "Bahasa Melayu",
    bi: "Bislama",
    bs: "Bosanski",
    ca: "Català",
    da: "Dansk",
    de: "Deutsch",
    et: "Eesti",
    en: "English",
    es: "Español",
    fr: "Français",
    sm: "Gagana Samoa",
    hr: "Hrvatski",
    it: "Italiano",
    rw: "Kinyarwanda",
    sw: "Kiswahili",
    lv: "Latviešu",
    lt: "Lietuvių",
    lb: "Lëtzebuergesch",
    hu: "Magyar",
    mt: "Malti",
    nl: "Nederlands",
    nb: "Norsk bokmål",
    uz: "O‘zbekcha",
    pl: "Polski",
    pt: "Português",
    ro: "Română",
    sq: "Shqip",
    sk: "Slovenčina",
    sl: "Slovenščina",
    so: "Soomaali",
    fi: "Suomi",
    sv: "Svenska",
    vi: "Tiếng Việt",
    tk: "Türkmençe",
    tr: "Türkçe",
    is: "Íslenska",
    cs: "Čeština",
    el: "Ελληνικά",
    be: "Беларуская",
    bg: "Български",
    ky: "Кыргызча",
    mk: "Македонски",
    mn: "Монгол",
    ru: "Русский",
    sr: "Српски",
    tg: "Тоҷикӣ",
    uk: "Українська",
    kk: "Қазақ тілі",
    hy: "Հայերեն",
    he: "עברית",
    ur: "اردو",
    ar: "العربية",
    fa: "فارسی",
    dv: "ދިވެހި",
    ne: "नेपाली",
    hi: "हिन्दी",
    bn: "বাংলা",
    si: "සිංහල",
    th: "ไทย",
    lo: "ລາວ",
    dz: "རྫོང་ཁ",
    my: "မြန်မာစာ",
    ka: "ქართული",
    ti: "ትግርኛ",
    am: "አማርኛ",
    km: "ភាសាខ្មែរ",
    zh: "中文",
    ja: "日本語",
    ko: "한국어",
};
